// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2eDOs","range":"MonthRangeSwitch_range__3KHXx","disabled":"MonthRangeSwitch_disabled__18Eb-"};